(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-iconCard-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Store initialized sliders to prevent duplicate initialization
    window.iconGridSliders = window.iconGridSliders || {};

    initializeAllSliders();

    window.addEventListener('resize', function () {
      initializeAllSliders();
    });

    function initializeAllSliders() {
      // Find all icon grid sections
      const sections = document.querySelectorAll('[data-section-id]');

      sections.forEach(function (section) {
        const sectionId = section.getAttribute('data-section-id');
        initializeSlider(sectionId);
      });
    }

    function initializeSlider(sectionId) {
      const sliderContainer = document.querySelector(`#mobile-slider-${sectionId}`);
      if (!sliderContainer) return;

      const cards = sliderContainer.querySelectorAll('.custom-iconGridBenefitCard');
      if (cards.length === 0) return;

      // Only initialize on mobile
      if (window.innerWidth <= 480) {
        const navigationContainer = document.querySelector(`[data-section-id="${sectionId}"] .slider-navigation`);
        if (!navigationContainer) return;

        const dots = navigationContainer.querySelectorAll('.dot');
        const prevBtn = navigationContainer.querySelector('.slider-prev');
        const nextBtn = navigationContainer.querySelector('.slider-next');

        // Check if already initialized
        if (window.iconGridSliders[sectionId]) {
          // Clean up existing listeners
          const oldSlider = window.iconGridSliders[sectionId];
          if (oldSlider.cleanup) {
            oldSlider.cleanup();
          }
        }

        let currentIndex = 0;
        let touchStartX = 0;
        let touchEndX = 0;
        let isDragging = false;

        // Event handlers
        const handlePrevClick = function () {
          goToPrevSlide();
        };

        const handleNextClick = function () {
          goToNextSlide();
        };

        const handleTouchStart = function (e) {
          touchStartX = e.touches[0].clientX;
          isDragging = true;
        };

        const handleTouchMove = function (e) {
          if (!isDragging) return;
          touchEndX = e.touches[0].clientX;
        };

        const handleTouchEnd = function () {
          if (!isDragging) return;
          isDragging = false;
          handleSwipe();
        };

        const handleMouseDown = function (e) {
          touchStartX = e.clientX;
          isDragging = true;
          e.preventDefault();
        };

        const handleMouseMove = function (e) {
          if (!isDragging) return;
          touchEndX = e.clientX;
        };

        const handleMouseUp = function () {
          if (!isDragging) return;
          isDragging = false;
          handleSwipe();
        };

        // Add event listeners
        prevBtn.addEventListener('click', handlePrevClick);
        nextBtn.addEventListener('click', handleNextClick);

        // Handle dot clicks
        const dotClickHandlers = [];
        dots.forEach((dot, index) => {
          const handler = function () {
            currentIndex = index;
            showSlide(currentIndex);
          };
          dot.addEventListener('click', handler);
          dotClickHandlers.push({ dot, handler });
        });

        // Setup touch events
        sliderContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
        sliderContainer.addEventListener('touchmove', handleTouchMove, { passive: true });
        sliderContainer.addEventListener('touchend', handleTouchEnd, { passive: true });

        // Mouse events for desktop testing
        sliderContainer.addEventListener('mousedown', handleMouseDown);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        // Store cleanup function
        window.iconGridSliders[sectionId] = {
          cleanup: function () {
            prevBtn.removeEventListener('click', handlePrevClick);
            nextBtn.removeEventListener('click', handleNextClick);

            dotClickHandlers.forEach(({ dot, handler }) => {
              dot.removeEventListener('click', handler);
            });

            sliderContainer.removeEventListener('touchstart', handleTouchStart);
            sliderContainer.removeEventListener('touchmove', handleTouchMove);
            sliderContainer.removeEventListener('touchend', handleTouchEnd);
            sliderContainer.removeEventListener('mousedown', handleMouseDown);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
          },
        };

        // Initialize slider
        resetSlider();
        showSlide(currentIndex);

        function handleSwipe() {
          const swipeThreshold = 50;
          const swipeDistance = touchEndX - touchStartX;

          if (swipeDistance > swipeThreshold) {
            goToPrevSlide();
          } else if (swipeDistance < -swipeThreshold) {
            goToNextSlide();
          }
        }

        function goToPrevSlide() {
          currentIndex = currentIndex > 0 ? currentIndex - 1 : cards.length - 1;
          showSlide(currentIndex);
        }

        function goToNextSlide() {
          currentIndex = currentIndex < cards.length - 1 ? currentIndex + 1 : 0;
          showSlide(currentIndex);
        }

        function showSlide(index) {
          // Reset all cards
          cards.forEach((card) => {
            card.classList.remove('active', 'prev', 'next');
            card.style.visibility = 'hidden';
          });

          // Calculate prev and next indices
          const prevIndex = index > 0 ? index - 1 : cards.length - 1;
          const nextIndex = index < cards.length - 1 ? index + 1 : 0;

          // Set classes for animation
          cards[prevIndex].classList.add('prev');
          cards[nextIndex].classList.add('next');
          cards[index].classList.add('active');

          // Make them visible
          cards[prevIndex].style.visibility = 'visible';
          cards[nextIndex].style.visibility = 'visible';
          cards[index].style.visibility = 'visible';

          // Update dots
          dots.forEach((dot) => dot.classList.remove('active'));
          dots[index].classList.add('active');
        }

        function resetSlider() {
          // Make container height match tallest card
          let maxHeight = 0;
          cards.forEach((card) => {
            card.style.position = 'static';
            card.style.visibility = 'visible';
            const height = card.offsetHeight;
            if (height > maxHeight) maxHeight = height;
            card.style.position = '';
            card.style.visibility = '';
          });

          sliderContainer.style.minHeight = maxHeight + 'px';
        }
      } else {
        // Reset to normal grid on larger screens
        cards.forEach((card) => {
          card.classList.remove('active', 'prev', 'next');
          card.style.opacity = '';
          card.style.position = '';
          card.style.visibility = '';
          card.style.transform = '';
        });
        sliderContainer.style.minHeight = '';

        // Clean up mobile slider if it exists
        if (window.iconGridSliders[sectionId] && window.iconGridSliders[sectionId].cleanup) {
          window.iconGridSliders[sectionId].cleanup();
          delete window.iconGridSliders[sectionId];
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ingredient-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.ingr-slider').slick({
      infinite: true,
      slidesToShow: 4.5,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: true,
  autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 1030,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
     if ($(window).width() <= 768) {
        $('.custom-product-card-container').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
     }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-slider"] && !Shopify.designMode) return;
  try {
    
    //   const copy = document.querySelector(".logos-slide").cloneNode(true);
    // document.querySelector(".logos").appendChild(copy);


    // Select the logos-slide element
  const logosSlide = document.querySelector(".logos-slide");

  // Clone the content to create a seamless infinite loop
  const copy = logosSlide.cloneNode(true);

  // Append the cloned content after the original content
  document.querySelector(".logos").appendChild(copy);

  } catch(e) { console.error(e); }
})();
})();
